<ng-container>
  <div class="header">
    <div class="label">
      {{ formData?.name }} - <span class="table-name">{{ 'CONFIG_FIELDS' | translate }}</span>
    </div>
    <div>
      <span (click)="closeDialog()" (keyup.enter)="closeDialog()" tabindex="0" aria-label="Close dialog">
        <i class="pi pi-times-circle close-icon" style="font-size: 1.5rem"></i>
      </span>
    </div>
  </div>
  <div class="body">
    <div class="d-flex justify-content-end align-items-center">
      <div class="formgroup-inline searchbox-button">
        <div class="field">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
            <input
              type="text"
              class="p-inputtext p-component p-element"
              name="search"
              placeholder="Search"
              [(ngModel)]="searchString"
              (input)="filterTableData($event)"
            />
            <span
              class="p-inputgroup-addon d-none"
              [ngClass]="{ 'p-inputgroup-addon': true, 'd-none': isClearSearchHidden }"
              (click)="clearSearch()"
              id="btnResetSearch"
              (keyup.enter)="clearSearch()"
              tabindex="1"
              aria-label="Clear search"
              ><i class="pi pi-times"></i
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-container">
      <p-table [value]="tableDataFilterResults" [style]="{ width: '100%' }">
        <ng-template #header>
          <tr>
            <th>
              <div class="header-label">
                <span>{{ 'FIELDS' | translate }}</span>
                <i
                  class="fa fa-info-circle"
                  showDelay="100"
                  hideDelay="100"
                  tooltipPosition="top"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="{{ 'WF_FIELDS_INFO_TEXT' | translate }}"
                >
                </i>
              </div>
            </th>
            <th class="text-center">
              <div class="header-group">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="selectDeselectAllFieldsSharedState"
                  (onChange)="selectDesectAllFieldsShared($event)"
                  [disabled]="disableField"
                ></p-checkbox>
                <div class="header-label">
                  <span>{{ 'FIELDS_SHARED' | translate }}</span>
                  <i
                    class="fa fa-info-circle"
                    showDelay="100"
                    hideDelay="100"
                    tooltipPosition="top"
                    tooltipStyleClass="label-tooltip custom-tooltip-properties"
                    pTooltip="{{ 'WF_FIELDS_SHARED_INFO_TEXT' | translate }}"
                  >
                  </i>
                </div>
              </div>
            </th>
            <th class="text-center">
              <div class="header-group">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="selectDeselectAllOverridePropertiesState"
                  (onChange)="selectDesectAllOverrideProperties($event)"
                  [disabled]="disableField"
                ></p-checkbox>
                <div class="header-label">
                  <div>
                    <span>{{ 'OVERRIDE_FIELD_PROP' | translate }}</span>
                    <br />
                    <span class="sub-text">{{ 'OVERRIDE_FIELD_PROP_SUB_TEXT' | translate }}</span>
                  </div>
                  <i
                    class="fa fa-info-circle"
                    showDelay="100"
                    hideDelay="100"
                    tooltipPosition="top"
                    tooltipStyleClass="label-tooltip custom-tooltip-properties"
                    pTooltip="{{ 'WF_OVERRIDE_PROP_INFO_TEXT' | translate }}"
                  >
                  </i>
                </div>
              </div>
            </th>
            <th class="text-center">
              <div class="header-group">
                <p-checkbox
                  [binary]="true"
                  [(ngModel)]="selectDeselectAllOverrideValuesState"
                  (onChange)="selectDesectAllOverrideValues($event)"
                  [disabled]="disableField"
                ></p-checkbox>
                <div class="header-label">
                  <span>{{ 'OVERRIDE_FIELD_VAL' | translate }}</span>
                  <i
                    class="fa fa-info-circle"
                    showDelay="100"
                    hideDelay="100"
                    tooltipPosition="top"
                    tooltipStyleClass="label-tooltip custom-tooltip-properties"
                    pTooltip="{{ 'WF_OVERRIDE_VALUE_INFO_TEXT' | translate }}"
                  >
                  </i>
                </div>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-field>
          <tr>
            <td [ngClass]="getFieldClass(field.sid)">
              {{ field.name }}
              <span *ngIf="hasWarning(field.sid)"
                ><i
                  class="pi pi-exclamation-triangle"
                  (mouseenter)="toggleWarningPopup(field.sid)"
                  (mouseleave)="toggleWarningPopup(field.sid)"
                ></i
              ></span>
              <span *ngIf="hasError(field.sid)">
                <i
                  class="pi pi-exclamation-circle"
                  (mouseenter)="toggleWarningPopup(field.sid)"
                  (mouseleave)="toggleWarningPopup(field.sid)"
                ></i
              ></span>
              <div class="warning-wrapper" *ngIf="isWarningVisible(field.sid)">
                <div
                  class="val-err"
                  [ngClass]="{ 'warning-popup': hasWarning(field.sid), 'error-popup': hasError(field.sid) }"
                >
                  <div class="warning-header">
                    <p>Warning</p>
                    <i class="pi pi-times"></i>
                  </div>
                  {{ getErrorMessage(field.sid) }}
                </div>
              </div>
            </td>
            <td class="text-center">
              <p-checkbox
                [binary]="true"
                [(ngModel)]="field.fieldShared"
                (onChange)="onFieldSharedClick(field, $event)"
                [disabled]="workflowStatusField?.sid === field.sid || disableField"
              ></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox
                [binary]="true"
                [(ngModel)]="field.overrideFieldProperty"
                (onChange)="onOverrideFieldPropertyClick(field, $event)"
                [disabled]="
                  workflowStatusField?.sid === field.sid ||
                  field.isSystemGeneratedField ||
                  disableField ||
                  !field.fieldShared
                "
              ></p-checkbox>
            </td>
            <td class="text-center">
              <p-checkbox
                [binary]="true"
                [(ngModel)]="field.overrideFieldValue"
                (onChange)="onOverrideFieldValueClick(field, $event)"
                [disabled]="
                  workFlowStatusFieldSid === field.sid ||
                  field.isSystemGeneratedField ||
                  field.isPrimaryKeyField ||
                  disableField ||
                  !field.fieldShared
                "
              ></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage let-columns>
          <tr class="no-records">
            <td colspan="4" class="text-center">
              {{ 'NO_RECORDS_FOUND' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="footer">
    <p-button
      label="{{ 'CANCEL' | translate }}"
      type="button"
      class="p-button-outlined custom-cancel-btn"
      (onClick)="closeDialog()"
      [disabled]="isSaveInProgress"
    />
    <p-button
      label="{{ 'CREATE' | translate }}"
      type="button"
      class="custom-save-btn"
      [disabled]="!isConfigDirty || disableField || isSaveInProgress"
      (onClick)="save()"
    />
  </div>
</ng-container>
